<template>
	<transition mode="out-in" name="leftIn">
		<div v-if="setores.result && ramais.result" class="row">
			<div v-for="setor in setores.result" :key="setor.ID" class="col-xl-4 col-lg-6 mb-3">

				<div class="card border-left-primary shadow h-100 py-2">
					<div class="card-body">
						<div class="row no-gutters align-items-center">
							<div class="col mr-2">
								<div class="text-xs font-weight-bold text-primary text-uppercase mb-1">{{ setor.NAME }}
								</div>

								<div v-for="ramal in ramais.result" :key="ramal.ID">
									<div v-if="ramal.PARENT_ID == setor.ID" class="row no-gutters align-items-center">
										<div class="col-auto">
											<div class="col-1 col-lg-1 col-xl-1">
												<font-awesome-icon v-if="ramal.STATUS == 3" icon="phone" size="xs"
													style="color: red" />
												<font-awesome-icon v-if="ramal.STATUS == 2 || ramal.STATUS == 4"
													icon="phone" size="xs" style="color: red" />
												<font-awesome-icon v-if="ramal.STATUS == 1" icon="phone" size="xs"
													style="color: green" />
											</div>
										</div>

										<div class="col">
											<div class="col-12 col-lg-12 col-xl-12">
												<small>{{ ramal.NAME }}</small> - <small>{{ ramal.EXTENSION }}</small>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-auto">
								<i class="fas fa-phone fa-2x text-gray-300"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-else>
			<Loading />
		</div>
	</transition>
</template>

<script>
import api from "@/mixins/api.js"
import { EventBus } from '@/event-bus.js';


export default {
	name: "Ramais",
	mixins: [api],

	data: () => {
		return {
			setores: { status: null, result: null },
			ramais: { status: null, result: null },
			looping: null,
			teste: true,
			selectedUnit: 0
		}
	},

	created() {
		this.get_setores();
		this.get_ramais();
		this.$emit('update:form_date', false);
		EventBus.$on('unit-changed', this.onUnitChanged);
		
	},

	beforeDestroy() {
		EventBus.$off('unit-changed', this.onUnitChanged);
	},

	methods: {
		get_to_date(date) {
			this.timestamps = false;
			this.teste = false;
		},

		onUnitChanged(unitId) {
			this.selectedUnit = unitId;
			this.get_setores();
		},

		async get_setores() {
			this.setores = await this.GET("Setor");

			if (this.$store.state.user.type != 3)
			{
				this.selectedUnit = this.$store.state.user.unidade_id;
			}

			if (this.selectedUnit != 0) {
				this.setores.result = this.setores.result.filter(setor => setor.PARENT_ID === this.selectedUnit);
			}
		},

		async get_ramais() {
			this.ramais = await this.GET("Ramal");
			this.refresh(this.teste);
		},

		refresh(aux) {
			if (aux) {
				clearTimeout(this.looping);
				this.looping = setTimeout(() => this.get_ramais(), 2000);
			}
		},


	},

	beforeRouteLeave(to, from, next) {
		this.teste = false;
		EventBus.$emit('reset-unit-filter');
		next();
	},
}
</script>

<style scoped></style>